import { NgModule } from '@angular/core';
import { KlickAufChecklistenLinkHandler } from './KlickAufChecklistenLinkHandler/KlickAufChecklistenLinkHandler';
@NgModule({
	declarations: [KlickAufChecklistenLinkHandler],
	imports: [],
	exports: [KlickAufChecklistenLinkHandler]
})
export class DirectivesModule {}



// WEBPACK FOOTER //
// ./src/directives/directives.module.ts